import { OfflineSalesComponent } from './offline-sales.component';
import { OfflineSalesService } from './offline-sales.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { OfflineSalesActionsModule } from './+offline-sales-actions/offline-sales-actions.module';

@NgModule({
  declarations: [
    OfflineSalesComponent
  ],
  imports: [
    CommonModule,
    OfflineSalesActionsModule,
    NgZorroAntdModule
  ],
  providers: [
    OfflineSalesService,
  ],
})
export class OfflineSalesModule { }
